export enum TripPlannerMode {
  auto,
  manual,
  aiAssistant,
  popularTrip,
  tripAsIs,
}
